module.exports = __webpack_public_path__ + "img/powerBallAd2.5715d77f.png";